export default __webpack_public_path__ + "static/media/icon_add_file_links.392d9d2d.jpg";